module.exports = __webpack_public_path__ + "img/hr-reactor-lights-color.77f48721.png";